<template>
  <span class="tb-head-title">
    <span v-if="title" class="tb-head-title__name">— {{ title }}</span>
    <code class="tb-head-title__barcode">{{ barcode }}</code>
  </span>
</template>

<script>
// 교재 편집 하위 화면의 머리 제목 옆에 붙는 "— 교재 제목 [바코드]".
// 콘텐츠 API 응답에는 제목이 없어 기본정보 화면과 같은 교재 API 로 읽습니다.
// 제목을 못 읽어도 편집은 되므로 알림 없이 바코드만 남깁니다.
export default {
  name: "TextbookHeadTitle",
  props: {
    barcode: { type: String, required: true },
  },
  data() {
    return {
      title: "",
    };
  },
  watch: {
    barcode: {
      immediate: true,
      handler: "getTitle",
    },
  },
  methods: {
    async getTitle(barcode) {
      this.title = "";
      try {
        const res = await this.$axios({
          method: "get",
          url: `/textbook/editor/textbooks/${encodeURIComponent(barcode)}`,
        });
        // 응답을 기다리는 사이 다른 교재로 넘어갔으면 버립니다.
        if (res.status === 200 && barcode === this.barcode) {
          this.title = res.data?.title || "";
        }
      } catch (error) {
        console.error("교재 제목 조회 실패:", error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/pineapple";

.tb-head-title {
  &__name {
    color: $p-point-deep;
    font-size: 20px;
    font-weight: 800;
    overflow-wrap: anywhere;
  }

  &__barcode {
    display: inline-block;
    margin-left: 8px;
    padding: 2px 8px;
    border-radius: $p-radius-sm;
    background: $p-panel-alt;
    color: $p-ink-mid;
    font-family: $p-font-mono;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0;
    vertical-align: middle;
    white-space: nowrap;
  }
}
</style>
